/* i18n helper: Texte kommen aus window.GDT (siehe layout/theme.liquid) */
function GD_TXT(key, fallback){ return (window.GDT && window.GDT[key]) ? window.GDT[key] : fallback; }
/* GLOBAL DIESEL — theme scripts */
(function(){
  'use strict';

  function pad(n){return String(n).padStart(2,'0');}

  /* ---- Dynamic styles (animations, busy state) ---- */
  function injectStyles(){
    if(document.getElementById('gd-dyn')) return;
    var s=document.createElement('style'); s.id='gd-dyn';
    s.textContent='@keyframes gdBump{0%{transform:scale(1)}30%{transform:scale(1.32)}55%{transform:scale(.9)}100%{transform:scale(1)}}.gd-bump{animation:gdBump .55s ease}.gd-pop{animation:gdBump .55s ease}.cart-busy{opacity:.5;pointer-events:none;transition:opacity .2s}';
    document.head.appendChild(s);
  }

  /* ---- UPS / cutoff countdown ---- */
  function cutoffInfo(hh,mm){
    var now=new Date();
    var c=new Date(now.getFullYear(),now.getMonth(),now.getDate(),hh,mm,0,0);
    var passed=now>c;
    if(passed){c.setDate(c.getDate()+1);}
    return {c:c,passed:passed};
  }
  function initCountdowns(){
    var nodes=document.querySelectorAll('[data-gd-countdown]');
    if(!nodes.length) return;
    function tick(){
      nodes.forEach(function(root){
        var hh=parseInt(root.getAttribute('data-h')||'17',10);
        var mm=parseInt(root.getAttribute('data-m')||'30',10);
        var info=cutoffInfo(hh,mm);
        var diff=Math.max(0,info.c-new Date());
        var h=Math.floor(diff/3.6e6);
        var m=Math.floor(diff%3.6e6/6e4);
        var s=Math.floor(diff%6e4/1000);
        var eh=root.querySelector('[data-cd-h]'), em=root.querySelector('[data-cd-m]'), es=root.querySelector('[data-cd-s]');
        if(eh)eh.textContent=pad(h);
        if(em)em.textContent=pad(m);
        if(es)es.textContent=pad(s);
        var comp=root.querySelector('[data-cd-compact]');
        if(comp)comp.textContent=pad(h)+' '+GD_TXT('hours','Std')+' '+pad(m)+' '+GD_TXT('minutes','Min');
        var st=root.querySelector('[data-cd-status]');
        if(st){
          st.textContent=info.passed?(st.getAttribute('data-after')||'Heute vorbei – Versand am nächsten Werktag')
                                     :(st.getAttribute('data-before')||'Versandbereit – heute noch raus');
        }
      });
    }
    tick();setInterval(tick,1000);
  }

  /* ---- Alternating announcement ---- */
  function initAnnounce(){
    document.querySelectorAll('[data-gd-announce]').forEach(function(box){
      var slides=box.querySelectorAll('.announce-slide');
      if(slides.length<2) return;
      var i=0;
      setInterval(function(){
        slides[i].classList.remove('active');
        i=(i+1)%slides.length;
        slides[i].classList.add('active');
      },4200);
    });
  }

  /* ---- Marquee (duplicate content for seamless loop) ---- */
  function initMarquee(){
    document.querySelectorAll('[data-gd-marquee]').forEach(function(track){
      if(track.dataset.dup) return; track.dataset.dup='1';
      track.innerHTML=track.innerHTML+track.innerHTML;
    });
  }

  /* ---- Count-up on scroll ---- */
  function initCounters(){
    var groups=document.querySelectorAll('[data-gd-counters]');
    if(!groups.length) return;
    function fmt(n){return n>=10000?n.toLocaleString('de-DE'):String(n);}
    function run(group){
      if(group.dataset.done) return; group.dataset.done='1';
      group.querySelectorAll('.count').forEach(function(el){
        var target=parseInt(el.getAttribute('data-target')||'0',10);
        var suffix=el.getAttribute('data-suffix')||'';
        var dur=1600,start=performance.now();
        function step(t){
          var p=Math.min(1,(t-start)/dur);
          var eased=1-Math.pow(1-p,3);
          el.textContent=fmt(Math.round(target*eased))+(p===1?suffix:'');
          if(p<1)requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }
    if(!('IntersectionObserver' in window)){groups.forEach(run);return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(x){if(x.isIntersecting)run(x.target);});
    },{threshold:.4});
    groups.forEach(function(g){io.observe(g);});
  }

  /* ---- Quantity steppers ---- */
  function initQty(){
    document.querySelectorAll('[data-qty]').forEach(function(box){
      if(box.dataset.qtyBound) return; box.dataset.qtyBound='1';
      var input=box.querySelector('input');
      box.querySelectorAll('[data-step]').forEach(function(btn){
        btn.addEventListener('click',function(){
          var v=parseInt(input.value||'1',10)||1;
          v+=parseInt(btn.getAttribute('data-step'),10);
          if(v<0)v=0;
          input.value=v;
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
      });
    });
  }

  /* ---- Product gallery thumbs ---- */
  function initGallery(){
    document.querySelectorAll('[data-gallery]').forEach(function(g){
      var main=g.querySelector('[data-gallery-main] img');
      if(!main) return;
      g.querySelectorAll('[data-thumb]').forEach(function(th){
        th.addEventListener('click',function(){
          var full=th.getAttribute('data-full');
          if(full)main.src=full;
        });
      });
    });
  }

  /* ---- Live cart count refresh ---- */
  function refreshCart(){
    if(!document.querySelector('[data-cart-count]')) return;
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(c){
        document.querySelectorAll('[data-cart-count]').forEach(function(n){
          n.textContent=c.item_count;
          n.style.display=c.item_count>0?'grid':'none';
        });
      }).catch(function(){});
  }

  /* ---- Fly-to-cart animation ---- */
  function cartLink(){ return document.querySelector('.header-actions a[aria-label="Warenkorb"]'); }
  function bumpCart(){ var l=cartLink(); if(!l)return; l.classList.remove('gd-bump'); void l.offsetWidth; l.classList.add('gd-bump'); }
  function popCount(){ var c=document.querySelector('[data-cart-count]'); if(!c)return; c.classList.remove('gd-pop'); void c.offsetWidth; c.classList.add('gd-pop'); }
  function flyFrom(img){
    var target=cartLink(); if(!target){ bumpCart(); popCount(); return; }
    var t=target.getBoundingClientRect();
    if(!img){ bumpCart(); popCount(); return; }
    var s=img.getBoundingClientRect();
    if(!s.width){ bumpCart(); popCount(); return; }
    var fly=document.createElement('img');
    fly.src=img.currentSrc||img.src;
    fly.style.cssText='position:fixed;left:'+s.left+'px;top:'+s.top+'px;width:'+s.width+'px;height:'+s.height+'px;object-fit:contain;background:#fff;border:1px solid #e3e6ea;border-radius:14px;padding:6px;z-index:99999;pointer-events:none;box-shadow:0 24px 50px -16px rgba(0,0,0,.45);transition:transform .78s cubic-bezier(.2,.75,.25,1),opacity .78s ease';
    document.body.appendChild(fly);
    var dx=(t.left+t.width/2)-(s.left+s.width/2);
    var dy=(t.top+t.height/2)-(s.top+s.height/2);
    requestAnimationFrame(function(){requestAnimationFrame(function(){
      fly.style.transform='translate('+dx+'px,'+dy+'px) scale(.1) rotate(8deg)';
      fly.style.opacity='.25';
    });});
    setTimeout(function(){ if(fly&&fly.parentNode)fly.parentNode.removeChild(fly); bumpCart(); popCount(); },800);
  }

  /* ---- AJAX add-to-cart (product page) ---- */
  function initAddToCart(){
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
      if(form.dataset.ajaxBound) return; form.dataset.ajaxBound='1';
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var btn=form.querySelector('[type="submit"]');
        if(btn && (btn.disabled||btn.getAttribute('aria-disabled')==='true')) return;
        var img=document.querySelector('.product-gallery [data-gallery-main] img')||document.querySelector('.product-gallery img');
        flyFrom(img);
        var old=btn?btn.innerHTML:'';
        if(btn){ btn.disabled=true; btn.innerHTML=GD_TXT('adding','Wird hinzugefügt …'); }
        fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
          .then(function(r){ if(!r.ok) throw r; return r.json(); })
          .then(function(){
            if(btn){ btn.innerHTML=GD_TXT('added','In den Warenkorb ✓'); setTimeout(function(){ btn.innerHTML=old; btn.disabled=false; },1700); }
            refreshCart();
          })
          .catch(function(){ if(btn){ btn.innerHTML=old; btn.disabled=false; } form.submit(); });
      });
    });
  }

  /* ---- Live cart quantity update (cart page) ---- */
  function initCartAjax(){
    var page=document.querySelector('.cart-wrap');
    if(!page) return;
    var busy=false;
    function bindInputs(){
      page.querySelectorAll('.qty input[name^="updates"]').forEach(function(inp){
        if(inp.dataset.cartBound) return; inp.dataset.cartBound='1';
        inp.addEventListener('change',function(){
          var name=inp.getAttribute('name');
          var a=name.indexOf('['), b=name.indexOf(']');
          if(a<0||b<0) return;
          var key=name.substring(a+1,b);
          var q=parseInt(inp.value||'0',10); if(isNaN(q)||q<0) q=0;
          updateLine(key,q);
        });
      });
    }
    function updateLine(key,q){
      if(busy) return; busy=true; page.classList.add('cart-busy');
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:q})})
        .then(function(){ return fetch(window.location.pathname+window.location.search,{headers:{'Accept':'text/html'}}); })
        .then(function(r){return r.text();})
        .then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var fresh=doc.querySelector('.cart-wrap');
          if(fresh){ page.innerHTML=fresh.innerHTML; }
          busy=false; page.classList.remove('cart-busy');
          initQty(); bindInputs(); refreshCart();
        })
        .catch(function(){ busy=false; page.classList.remove('cart-busy'); });
    }
    bindInputs();
  }

  /* ---- Delivery date estimate (business days, cutoff-aware) ---- */
  function initDelivery(){
    var nodes=document.querySelectorAll('[data-delivery-date]');
    if(!nodes.length) return;
    var GD_LOC=(window.GDT&&window.GDT.locale)||document.documentElement.lang||'de';
    function nameOf(d,opt){ try{ return d.toLocaleDateString(GD_LOC,opt); }catch(e){ return ''; } }
    function weekend(d){return d.getDay()===0||d.getDay()===6;}
    function addBiz(d,n){var x=new Date(d);while(n>0){x.setDate(x.getDate()+1);if(!weekend(x))n--;}return x;}
    function fmt(d,withMonth){
      var wd=nameOf(d,{weekday:'short'});
      var day=nameOf(d,{day:'numeric'})||String(d.getDate());
      var mon=withMonth?nameOf(d,{month:'short'}):'';
      return (wd?wd+' ':'')+day+(mon?' '+mon:'');
    }
    nodes.forEach(function(el){
      var h=parseInt(el.getAttribute('data-h')||'17',10);
      var m=parseInt(el.getAttribute('data-m')||'30',10);
      var lmin=parseInt(el.getAttribute('data-lead-min')||el.getAttribute('data-lead')||'1',10);
      var lmax=parseInt(el.getAttribute('data-lead-max')||el.getAttribute('data-lead')||String(lmin),10);
      var now=new Date();
      var ship=new Date(now.getFullYear(),now.getMonth(),now.getDate());
      var cutoff=new Date(now.getFullYear(),now.getMonth(),now.getDate(),h,m,0,0);
      if(now>cutoff) ship.setDate(ship.getDate()+1);
      while(weekend(ship)) ship.setDate(ship.getDate()+1);
      var d1=addBiz(ship,lmin), d2=addBiz(ship,lmax);
      var pre=el.getAttribute('data-pre')||GD_TXT('delivered','Geliefert');
      var txt;
      if(lmin===lmax){txt=pre+' '+fmt(d1,true);}
      else if(d1.getMonth()===d2.getMonth()){txt=pre+' '+fmt(d1,false)+' – '+fmt(d2,true);}
      else{txt=pre+' '+fmt(d1,true)+' – '+fmt(d2,true);}
      el.textContent=txt;
    });
  }

  function ready(fn){
    if(document.readyState!=='loading')fn();
    else document.addEventListener('DOMContentLoaded',fn);
  }
  ready(function(){
    injectStyles();
    initCountdowns();initAnnounce();initMarquee();initCounters();
    initQty();initGallery();initDelivery();refreshCart();
    initAddToCart();initCartAjax();
  });
  // Re-init in Shopify theme editor when sections reload
  document.addEventListener('shopify:section:load',function(){
    injectStyles();
    initCountdowns();initAnnounce();initMarquee();initCounters();
    initQty();initGallery();initDelivery();initAddToCart();initCartAjax();
  });
})();
